import * as api from "./client.js";

// wp-syncer registers GET /api/v1/image-hashes with discovery; the staff-bff default convention
// projects it to /api/v1/wp-syncer/image-hashes. The api client prepends the "/api" base.
const IMAGE_HASHES_BASE = "/v1/wp-syncer/image-hashes";

export type ImageHashEntry = {
  url: string;
  hash: string;
  filename: string;
  content_type: string | null;
  byte_size: number | null;
  created_at: string;
  last_seen_at: string;
};

export type ListImageHashesResponse = {
  items: ImageHashEntry[];
  pagination: { total: number; limit: number; offset: number; has_more: boolean };
  request_id: string;
};

export type ImageHashContentTypeBreakdown = {
  content_type: string | null;
  count: number;
};

export type ImageHashStatsResponse = {
  total: number;
  total_bytes: number;
  by_content_type: ImageHashContentTypeBreakdown[];
  oldest_created_at: string | null;
  newest_last_seen_at: string | null;
  request_id: string;
};

export type ClearImageHashesResponse = {
  deleted: number;
  request_id: string;
};

export type ImageHashFilters = {
  limit?: number;
  offset?: number;
  search?: string;
};

export const imageHashesService = {
  listImageHashes(filters: ImageHashFilters = {}): Promise<ListImageHashesResponse> {
    const params = new URLSearchParams();
    if (filters.limit != null) params.set("limit", String(filters.limit));
    if (filters.offset != null) params.set("offset", String(filters.offset));
    if (filters.search) params.set("search", filters.search);
    const qs = params.toString();
    return api.get<ListImageHashesResponse>(`${IMAGE_HASHES_BASE}${qs ? `?${qs}` : ""}`);
  },

  getImageHashStats(): Promise<ImageHashStatsResponse> {
    return api.get<ImageHashStatsResponse>(`${IMAGE_HASHES_BASE}/stats`);
  },

  clearImageHashes(): Promise<ClearImageHashesResponse> {
    return api.del<ClearImageHashesResponse>(IMAGE_HASHES_BASE);
  },
};
